module.exports = __webpack_public_path__ + "img/dianshang.b96d7bea.png";